import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { canSendAnalytics } from './analytics';

function reportMetric(metric: Metric) {
  const valueForGa =
    metric.name === 'CLS' ? Math.round(metric.value * 1000) : Math.round(metric.value);

  const endpoint = import.meta.env.VITE_WEB_VITALS_ENDPOINT as string | undefined;
  if (endpoint && navigator.sendBeacon) {
    const payload = JSON.stringify({
      name: metric.name,
      value: metric.value,
      id: metric.id,
      rating: metric.rating,
      delta: metric.delta,
      navigationType: metric.navigationType,
      path: window.location.pathname,
    });
    navigator.sendBeacon(endpoint, new Blob([payload], { type: 'application/json' }));
  }

  // 與「資料分享」一致：關閉時不寫入 dataLayer／gtag（避免仍被 GTM／GA 收進）
  if (canSendAnalytics()) {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      event: 'web_vitals',
      metric_name: metric.name,
      metric_value: valueForGa,
      metric_id: metric.id,
      metric_rating: metric.rating,
      metric_delta: metric.delta,
      page_path: window.location.pathname,
    });

    window.gtag('event', 'web_vitals', {
      metric_name: metric.name,
      value: valueForGa,
      metric_id: metric.id,
      metric_rating: metric.rating,
    });
  }
}

export function initWebVitals() {
  if (typeof window === 'undefined') return;

  const handle = (metric: Metric) => {
    if (import.meta.env.DEV) {
      console.debug('[web-vitals]', metric.name, metric.value, metric.rating);
      return;
    }
    reportMetric(metric);
  };

  onCLS(handle);
  onINP(handle);
  onLCP(handle);
  onFCP(handle);
  onTTFB(handle);
}
